// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","518":"preview-api","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"c7b28ea9f6fd86e344ad","303":"1825d7b83b7554e1b6d2","495":"5622f23aedcbc310a1de","518":"8f71b53d7ad2b21c546d","826":"f1a91babddb5937a8750","946":"bb887da77b2bece79ed1"}[chunkId] + ".js";
};